<template>
  <div class="bj_show">

    <div class="container-fluid container-fluid-a">
      <div class="row-fluid">
        <!--最新活动-->
        <div class="span12 text-left">
          <div class="jumbotron" style="padding-top: 20px;padding-bottom: 20px;">
            <div class="container">
              <div class="row">
                <!-- <div class="col-2 middle" style="margin-right:10px">
                  <img :src=list.avatar_url width="50" height="50" />
                </div> -->
                <div class="col-2 middle" style="margin-left:-10px;margin-right:10px;margin-top:5px">
                  <img :src=list.avatar_url width="50" height="50" v-if="list.avatar_url" />
                  <div class="is" v-else>暂&nbsp;无<br>图&nbsp;片</div>
                </div>
                <div class="col-6">
                  <!-- <div>
                    <h4>{{list.title}}</h4>
                  </div> -->
                  <div>
                    <h5 style="width:130px">{{list.title?list.title:list.username}}</h5>
                  </div>
                  <div>服务范围（{{list.range}}）</div>
                  <!-- <div>{{群团组织}}</div> -->
                </div>
                <div class="col-4 text-right middle">
                  <span class="label label-default" style="padding-top:6px" v-if="list.key_id == 1">群团组织</span>
                  <span class="label label-default" style="padding-top:6px" v-if="list.key_id == 2">社会组织</span>
                  <span class="label label-default" style="padding-top:6px" v-if="list.key_id == 3">个人</span>
                </div>
              </div>
            </div>
            <!-- <div class="tt_10" v-if="list.key_id != 3">服务社区：
              <span class="label label-primary label_50" v-if="list1">{{list1.entry_community}}</span>
              <span class="label label-primary label_50">未来社区</span>
            </div> -->
            <div class="tt_10">联络人员：<span>{{list.username}}</span></div>
            <div class="tt_10">联系电话：<span>{{list.telephone}}</span></div>

            <div v-if="list.key_id != 3">
              <i class="iconfont i2" v-if="icon" @click.stop="iconbtn()">&#xe771;</i>
              <i class="iconfont ic2" v-else @click.stop="iconbtn()">&#xe629;</i>
            </div>
            <div v-else>
              <i class="iconfont i3" v-if="icon" @click.stop="iconbtn()">&#xe771;</i>
              <i class="iconfont ic3" v-else @click.stop="iconbtn()">&#xe629;</i>
            </div>

          </div>

          <div v-if="list.key_id != 3">
            <h4>组织介绍</h4>
            <div class="row">
              <div class="col-12" style="text-indent:2em;">
                {{list.explain}} </div>
            </div>
          </div>
          <div class="col-12" style="height: 3px;"></div>
          <div class="tt_10 tt_x_10">
            <h4>服务项目</h4>
          </div>
          <div class="row">
            <div class="col-6 col-6-6" @click="showcurrent(item.id,item.entry_address_xy,item.entry_address)"
              v-for="(item,index) in list2" :key="index">
              <div class="jumbotron  text-center" style="padding: 15px 0px;" v-if="item">
                {{item.entry_name?item.entry_name:item.title}}</div>
              <div v-else>暂无服务</div>
            </div>
          </div>
          <div>
            <h4>联系地址</h4>
            <div class="row">
              <div class="col-12" style="text-indent:2em;">
                {{list.address}} </div>
            </div>
          </div>
          <!-- <div class="col-12" style="height: 3px;"></div>
          <div>
            <h4>服务范围</h4>
            <div class="row">
              <div class="col-12" style="text-indent:2em;">
                {{list.range}} </div>
            </div>
          </div> -->
          <!-- <div class="tt_10 tt_x_10">
            <h4>服务范围</h4>
          </div>
          <div class="row">
            <div class="col-6 col-6-6" @click="show = true" v-for="(item,index) in button" :key="index">
              <div class="jumbotron  text-center" style="padding: 15px 0px;">{{item}}</div>
            </div>
            <div class="col-6 col-6-6">
              <div class="jumbotron text-center" style="padding: 15px 0px;">心理咨询</div>
            </div>
            <div class="col-6 col-6-6">
              <div class="jumbotron text-center" style="padding: 15px 0px;">心理咨询</div>
            </div>
          </div> -->
          <!-- <div v-show="show">
            <div class="tt_10 tt_x_10">
              <h4>个人资料</h4>
            </div>
            <div class="row">
              <div class="col-12">
                <form class="bs-example bs-example-form" role="form">
                  <div class="input-group">
                    <span class="input-group-addon">联系姓名</span>
                    <input type="text" class="form-control" placeholder="填写求助者的真实姓名">
                  </div>
                  <br>
                  <div class="input-group">
                    <span class="input-group-addon">联系电话</span>
                    <input type="text" class="form-control" placeholder="填写求助者的联系电话">
                  </div>
                  <br>
                  <div class="input-group">
                    <textarea rows="2" class="form-control" placeholder="详细描述"></textarea>
                  </div>
                  <br>
                  <div class="col-12">
                    <button class='submit_btn' style="margin-top:0px;">提交资料</button>
                  </div>
                </form>

              </div>
            </div>
          </div> -->
        </div>

      </div>
      <div id="d_p_80"></div>
    </div>
    <div class="pop" @click="show = false" v-show="show"></div>
    <div class="edit" v-show="show">
      <div class="tt_10 tt_x_10">
        <h4 class="text-left">个人资料</h4>
      </div>
      <div class="row">
        <div class="col-12">

          <div class="input-group">
            <span class="input-group-addon">联系姓名</span>
            <input type="text" class="form-control"
              style="border: 1px solid #ccc !important;padding-left: 12px !important;" placeholder="填写求助者的真实姓名"
              v-model="name">
          </div>
          <br>
          <div class="input-group">
            <span class="input-group-addon">联系电话</span>
            <input type="text" class="form-control"
              style="border: 1px solid #ccc !important;padding-left: 12px !important;" placeholder="填写求助者的联系电话"
              v-model="tel" @change="check">
          </div>
          <p v-if="err" class="text-left" style="color: red;margin: 1px;">手机号码不正确</p>
          <br v-if="err == 0">
          <div class="input-group">
            <textarea rows="2" class="form-control" placeholder="详细描述" v-model="detailed"></textarea>
          </div>
          <br>
          <div class="col-12" @click="submit">
            <button class='submit_btn' style="margin-top:0px;">提交资料</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import user_model from '../tool/user_model'
import pop from './popup.vue'
export default {
  data () {
    return {
      id: '',
      icon: true,
      showji: false,
      show5: false,
      list: [],
      show: false,
      button: [],
      list1: '',
      name: '',
      tel: '',
      err: 0,
      detailed: '',
      list2: [],
      current: '',
      openid: '',
      openid1: '',
      uid: 0,
      //showcurrent:"",
      entry_address: "",
    }
  },
  components: {
    pop
  },
  methods: {
    iconbtn () {
      if (this.icon == false) {
        this.$api.getAPI('mutual/click/?appid=202108&type_id=5001&state=1', { params: { openid: this.openid } }).then(res => {
          // console.log(res.data.data.data[0].models);
          for (let i = 0; i < res.data.data.data[0].models.length; i++) {
            // console.log(res.data.data[0].models[i].connect == window.location.href);
            if (res.data.data.data[0].models[i].key_value == '202108' + '5001' + this.openid + this.$route.query.id && res.data.data.data[0].models[i].state == 1) {
              // console.log(this.icon);
              this.id = res.data.data.data[0].models[i].id
              console.log(this.id);
              this.$api.getAPI('mutual/click/' + this.id + '?appid=202108&type_id=5001&state=1', { params: { openid: this.openid } }).then(res => {
                console.log(res.data);
                let data = new FormData()
                data.append('state', 2)
                data.append('openid', this.openid)
                this.$api.postAPI("mutual/click/" + this.id + "?appid=202108&type_id=5001&state=1", data).then(res => {
                  console.log(res);
                })
              })
            }
          }
        })
      } else {
        let data = new FormData()
        data.append('openid', this.openid)
        data.append('key_value', '202108' + '5001' + this.openid + this.$route.query.id)
        if (this.list.title) {
          data.append('key_name', this.list.title)
        } else {
          data.append('key_name', this.list.username)
        }
        data.append('key_img', this.list.avatar_url)
        data.append('connect', window.location.hash)
        data.append('state', 1)
        this.$api.postAPI(`mutual/click/?appid=202108&type_id=5001`, data).then(res => {
          console.log(res);
        })
      }
      this.icon = !this.icon
    },
    itshow1 () {
      this.show5 = false
      this.show = !this.show
    },
    editshow () {
      this.showji = false
      this.$router.push('/home_help')
    },
    showcurrent (index, entry_address_xy, entry_address) {
      //alert("aaa")
      this.show = true
      this.current = index
      this.entry_address_xy = entry_address_xy
      this.entry_address = entry_address
    },
    submit () {
      var userinfo = this.$api.getUserInfo();
      console.log(userinfo)
      console.log(userinfo.openid)
      //return
      // console.log(this.current, this.list2[this.current].entry_address_xy);
      // console.log(this.name, this.tel, this.detailed, this.list.entry_address, this.list.entry_address_xy);
      if (this.name != '' & this.tel != '' & this.detailed != '') {
        let data = new FormData()
        data.append('openid', userinfo.openid)
        data.append('nick_name', userinfo.username)
        data.append('avatar_url', userinfo.avatar_url)
        data.append('username', this.name)
        data.append('telephone', this.tel)
        data.append('address', userinfo.address)
        data.append('detailed', this.detailed)

        // data.append('username', this.name)
        // data.append('telephone', this.tel)
        // data.append('assistance_text', this.detailed)
        // data.append('assistance_address', this.list2[this.current].entry_address)
        // data.append('assistance_address_xy', this.list2[this.current].entry_address_xy)
        // data.append('nick_name', this.list2[this.current].entry_type)
        this.$api.postAPI(`mutual/task_server/?appid=202108&type_id=10001&state=1&sid=` + this.current + "&uid=" + this.$route.query.id + "&community=" + userinfo.community, data).then(res => {
          console.log(res);
          this.show = !this.show
          var socket = new WebSocket("ws://dns1.hsnms.com:17072/web/join/?appid=0&openid=4&nickname=ceosgg");
          //添加状态判断，当为OPEN时，发送消息
          var message = {
            openid: userinfo.openid,
            assistance_address_xy: this.entry_address_xy,
            assistance_text: this.detailed,
            username: this.name,
            assistance_address: this.entry_address,
            telephone: this.tel,
            assistance_time: '',
            assistance_paid: '无偿'
          };
          message = JSON.stringify(message);
          //添加事件监听
          socket.addEventListener('open', function () {
            socket.send(message)
          });
          this.showji = true
          //alert('发布成功')
          this.$Message.success("提交成功！")

        });
      } else {
        this.show = !this.show
        this.show5 = true
      }

    },
    check () {
      if (!(/^1[34578]\d{9}$/.test(this.tel))) {
        this.err = 1
        // console.log(3);
        return false
      } else {
        this.err = 0
      }
    }
  },
  mounted () {
    const info = user_model.getUserinfo()
    this.openid = info.openid
    var id = this.$route.query.id;
    this.name = info.username;
    this.tel = info.telephone;
    this.$api.getAPI("mutual/attribute/" + id + "?appid=202108&type_id=4001&state=1", {}).then(res => {
      this.list = res.data.data.models
      this.uid = res.data.data.models.id;
    })
    //服务项目
    this.$api.getAPI("mutual/server/?appid=202108&type_id=2001&state=1", {
      ojb_id: id
    }).then(res => {
      // this.list = res.data.data.models
      this.list2 = res.data.data.data[0].models;
      console.log(res.data.data.data[0].models);
    })
    //收藏
    // this.$api.getAPI('mutual/click/?appid=202108&type_id=5001&page=0&size=999&state=1', { params: { openid: this.openid } }).then(res => {
    //   console.log(res.data.data.data[0].models);
    //   for (let i = 0; i < res.data.data.data[0].models.length; i++) {
    //     // console.log(res.data.data[0].models[i].connect == window.location.href);
    //     if (res.data.data.data[0].models[i].key_value == '202108' + '5001' + this.openid + this.$route.query.id && res.data.data.data[0].models[i].state == 1) {
    //       this.icon = false
    //       // console.log(this.icon);
    //       this.id = res.data.data.data[0].models[i].id
    //       this.$api.getAPI('mutual/click/' + this.id + '?appid=202108&type_id=5001&state=1', { params: { openid: this.openid } }).then(res => {
    //         console.log(res.data.data);
    //       })
    //     }
    //   }
    // })
    this.$api.getAPI('mutual/click/?appid=202108&type_id=5001&page=0&size=999&state=1', { params: { openid: this.openid } }).then(res => {
      console.log(res.data.data.data[0].models);
      // console.log(res.data.data.data[0].models[0].id);
      for (let i = 0; i < res.data.data.data[0].models.length; i++) {
        // console.log(res.data.data.data[0].models[i].key_value == '202108' + '5001' + this.openid + this.$route.query.id);
        if (res.data.data.data[0].models[i].key_value == '202108' + '5001' + this.openid + this.$route.query.id && res.data.data.data[0].models[i].state == 1) {
          // console.log(1);
          // console.log(res.data.data.data[0].models[i].id);
          this.icon = false
          // console.log(this.icon);
          this.id = res.data.data.data[0].models[i].id
          console.log(this.id);
          this.$api.getAPI('mutual/click/' + this.id + '?appid=202108&type_id=5001&state=1', { params: { openid: this.openid } }).then(res => {
            console.log(res.data);
          })
        }
      }
    })
  }
}

</script>

<style>
.input-group input {
  border: 1px solid #ccc;
  padding-left: 12px;
}
.label-primary {
  color: #3480fa;
  background-color: #ffd986;
}
.label_50 {
  border-radius: 50px/50px;
}
.i2 {
  position: absolute;
  right: 30px;
  top: 106px;
  font-size: 25px !important;
}
.ic2 {
  position: absolute;
  right: 30px;
  top: 112px;
  font-size: 18px !important;
  color: #ffd986;
}
.i3 {
  position: absolute;
  right: 25px;
  top: 56px;
  font-size: 25px !important;
}
.ic3 {
  position: absolute;
  right: 25px;
  top: 60px;
  font-size: 18px !important;
  color: #ffd986;
}
.pop {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.15);
  z-index: 99;
}
.edit {
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  height: 300px;
  background: #fff;
  z-index: 990;
  overflow: hidden;
  border-radius: 20px;
  padding: 10px 20px;
  box-shadow: 0px 1px 3px 1px rgb(0 0 0 / 15%);
}
.edit h4 {
  margin: 0;
}

.bj_show {
  background: #01b2c2;
  height: 12rem;
}

.container-fluid-a {
  position: absolute;
  top: 50px;
}
.is {
  width: 50px;
  text-align: center;
  line-height: 25px;
  height: 50px;
  font-size: 14px;
  border: 1px solid #c0c0c0;
}
.jumbotron {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/server_user_shows.vue